import {
  KnownAction,
  RECEIVE_ALL_USERS,
  REQUEST_ALL_USERS,
  REQUEST_SETMODALSTATE,
  REQUEST_SETActiveTab,
  REQUEST_SETDropRight,
} from "./CustomerBills";
import { Action, createStore, Reducer, Store } from "redux";
import {
  BAN,
} from "./Interfaces";


export interface CustomerBillsState {
  bans: BAN[];
  ModalsState: Map<string, boolean>;
  isError: boolean;
  isLoading: boolean;
  activeTab: string;
  btnDropright: boolean[];
}

export const initialState: CustomerBillsState = {

  bans: [],
  ModalsState: new Map(),
  isLoading: false,
  isError: false,
  activeTab: '1',
  btnDropright: [],
};

export const reducer: Reducer<CustomerBillsState> = (state: CustomerBillsState | undefined, incomingAction: Action): CustomerBillsState => {
  if (state === undefined) {
    return initialState;
  }

  const action = incomingAction as KnownAction;
  switch (action.type) {
    case REQUEST_ALL_USERS: {
      return {
        bans: state.bans,
        isLoading: true,
        isError: state.isError,
        ModalsState: state.ModalsState,
        activeTab:state.activeTab,
        btnDropright: state.btnDropright
      };
    }
    case RECEIVE_ALL_USERS:
      return {
        bans: action.payload.bans,
        isLoading: false,
        isError: action.isError,
        ModalsState: state.ModalsState,
        activeTab: state.activeTab,
        btnDropright: state.btnDropright
      };

    case REQUEST_SETMODALSTATE: {
      let newstate = { ...state };
      newstate.ModalsState.set(action.ModalName, action.ModalOpen);
      return newstate;
    }
    case REQUEST_SETActiveTab: {
      let newstate = { ...state };
      newstate.activeTab = action.activeTab;
      return newstate;
    }
    case REQUEST_SETDropRight: {
      let newstate = { ...state };
      newstate.btnDropright[action.index] = action.value;
      return newstate;
    }
    default:
      return state;

  }

};

const store: Store<CustomerBillsState, KnownAction> = createStore(reducer);

export { store };
